import { doFetchOrderProductsList } from '@/services/product.service';
import { doFetchOrderProductsListGraphQL } from '@/services/user.service';
import { getField, updateField } from 'vuex-map-fields';
import { snakeToCamel } from '@/services/util.service';

export const meProductList = {
    namespaced: true,
    state: {
        inProgress: true,
        orderProductsList: [],
        totalItems: 0
    },
    getters: {
        getField
    },
    mutations: {
        updateField,

        inProgress(state, yesOrNo) {
            state.inProgress = yesOrNo
        },
        setOrderProductsList(state, list) {
            state.orderProductsList = list
        },
        setTotalCount(state, count) {
            state.totalItems = count
        }
    },
    actions: {
        fetchOrderProductsList: async ({ commit }, payload) => {
            try {
                commit('inProgress', true)

                const variables = {
                    currentPage: payload.page || 1,
                    pageSize: payload.pageSize || 20,
                }

                let orderProductsList = await doFetchOrderProductsListGraphQL(variables)

                if (orderProductsList) {
                    commit('inProgress', false)

                    // ✅ IMPORTANT
                    commit('setOrderProductsList', orderProductsList.items)
                    commit('setTotalCount', orderProductsList.totalCount)
                }
            } catch (error) {
                commit('inProgress', false)
                console.error('Error fetching orders:', error)
            }
        }
    },

}
